import { IController } from 'angular';
import { ISchool } from '../../../ng2/shared/typings/interfaces/school.interface';
import { ISchoolSupport } from '../../../ng2/shared/typings/interfaces/support.interface';
import { IUser } from '../../../ng2/shared/typings/interfaces/user.interface';

export class MySupportsCtrl implements IController {
  static $inject: string[] = ['supportsForCurrentUser', 'currentSchool', 'currentUser', 'Support'];

  public activeSupportsForCurrentUser: ISchoolSupport[];
  public title: string;

  constructor(
    private supportsForCurrentUser,
    private currentSchool: ISchool,
    private currentUser: IUser,
    private Support,
  ) {
    this.title = 'My supports';
    this.activeSupportsForCurrentUser = this.Support.getNotDeletedSupports(supportsForCurrentUser);
    this.currentSchool = currentSchool;
    this.currentUser = currentUser;
  }
}
